<script>
    import { checkSession_getSelf, apiRequest, communicationError, apiFetchResource, toggleComments, commentPost } from "../lib/api";
    import { displayComments, displayNames, shareGroups, timestamp2date } from "../lib/display";
    import { priorities, tickets as tickets_trs } from "../lib/translations.json"
    import { onMount } from "svelte";

    /** @import {User, Session} from "../lib/api" */

    /** @type {User} */
    let user = $state();
    /** @type {Session} */
    let session = $state();
    /** @type {Object.<str, str>} */
    let groups = $state({});
    /** @type {Object.<str, str>} */
    let userlist = $state({});
    let selectedTab = $state("user_tickets");

    /**
    @typedef {Object} Ticket
    @property {string} author
    @property {number} creationDate
    @property {string[]} groups
    @property {number} comments
    @property {string} title
    @property {string} location
    @property {number} priority
    @property {string} description
    */

    
    /** @type {Promise<Object.<str, Ticket>} */
    let tickets = $state({});
    /** @type {Ticket} */
    let ticketInput = $state({});
    /** @type {string?} */
    let ticketId = $state();
    let cmdStr = $state("Créer");


    /** @type {HTMLDialogElement} */
    let createTicketDialog = $state();


    let ticketSortMethod = (t1, t2) => t2.creationDate - t1.creationDate;
    let ticketFilterMethod = (_) => true;
    
    /** @returns {[string, Ticket][]} */
    const generateTicketView = () => Object.entries(tickets).filter(t => ticketFilterMethod(t[1])).sort((t1, t2) => ticketSortMethod(t1[1], t2[1]));

    async function submitTicket() {
        if (ticketId) {
            const resp = await apiRequest(session, "tickets.modify", {id: ticketId, data: ticketInput});
            if (!resp.ok) communicationError("Erreur modification poste");
        } else {
            const resp = await apiRequest(session, "tickets.create", ticketInput);
            if (!resp.ok) communicationError("Erreur creation poste");
        }

        tickets = await apiFetchResource(session, "tickets.list");
        createTicketDialog.close();
    }

    /** @param {string} id  */
    async function completeTicket(id) {
        if (!confirm(`Terminer le ticket ${tickets[id].title} ?`)) return;
        const resp = await apiRequest(session, "tickets.complete", {id: id});
        if (!resp.ok) communicationError("Erreur suppression ticket");
        tickets = await apiFetchResource(session, "tickets.list");
    }

    /** @param {string} id  */
    async function removeTicket(id) {
        if (!confirm(`Supprimer le ticket ${tickets[id].title} ?`)) return;
        const resp = await apiRequest(session, "tickets.remove", {id: id});
        if (!resp.ok) communicationError("Erreur suppression ticket");
        tickets = await apiFetchResource(session, "tickets.list");
    }


    onMount(async ()=>{
        ({session: session, user: user, groups: groups, names: userlist} = await checkSession_getSelf());

        tickets = await apiFetchResource(session, "tickets.list");
    });
</script>

<header>
    <a href="/home" id="home-button">
        <img class="icon" src="/www/favicon.png" alt="Letas Icon" />
        <span>{user?.name ?? ""}</span>
    </a>
    <div style="flex-grow: 1;"></div>
    <label class="tab">
        Mes Tickets Actifs
        <input type="radio" name="tab" value="user_tickets" bind:group={selectedTab} checked />
    </label>
</header>

<section id="tool-bar">
    <button onclick={() => {
        cmdStr = "Créer";
        ticketInput = {};
        ticketId = undefined;
        createTicketDialog.style.cssText = `--background-base-color: var(--blue);`
        createTicketDialog.showModal();
    }}> 󰺪 </button>
</section>

<div class="masonry-layout">
    {#each generateTicketView() as [id, ticket]}
        <div class="box gradient" style="--background-base-color: {priorities[ticket.priority].color ?? "white"};">
            <h2>{ticket.title}</h2>
            <div class="dark-bg details">
                 : <em style="color: {priorities[ticket.priority].color};">{priorities[ticket.priority].name}</em> <br/>
                 : <em>{tickets_trs.locations[ticket.location]}</em> <br/>
                Posté par <em>{userlist[ticket.author]}</em> le {timestamp2date(ticket.creationDate)} <br/>
                Groupes : {displayNames({...userlist, ...groups}, ticket.groups)}
            </div>
            {#if ticket.description?.length}
                <div class="dark-bg description">
                    {@html ticket.description}
                </div>
            {/if}
            <div class="flex-scroll">
                {#if user.privileges.includes("tickets.moderator") || shareGroups(user.groups, ticket.groups)}
                    <button class="dark-button" onclick={()=>{toggleComments(id, ticket, session, "tickets")}}>󰅺 Commenter {displayComments(ticket.comments)}</button>
                    <button class="dark-button" onclick={()=>{completeTicket(id)}}> Terminer</button>
                {/if}
                {#if user.privileges.includes("tickets.moderator") || ticket.author == user.id}
                    <button
                        class="dark-button"
                        onclick={()=>{
                            ticketInput = ticket;
                            ticketId = id;
                            cmdStr = "Modifier";
                            createTicketDialog.style.cssText = `--background-base-color: ${priorities[ticketInput.priority].color};`
                            createTicketDialog.showModal();
                        }}
                    > Modifier</button>
                {/if}
                {#if user.privileges.includes("tickets.moderator")}
                    <button class="dark-button" onclick={()=>{removeTicket(id)}}> Supprimer</button>
                {/if}
            </div>
            {#if ticket.commentsVisible}
                {#if ticket.comments?.length}
                    <ul class="dark-bg comments">
                        {#each ticket.comments as comment}
                            <li>
                                <small>{timestamp2date(comment.timestamp)}</small> <em>{userlist[comment.author]}</em> : {comment.comment}
                            </li>
                        {/each}
                    </ul>
                {/if}
                <form style="display: flex; width: 100%;" onsubmit={e=>{
                    e.preventDefault();
                    const f = new FormData(e.target);
                    commentPost(id, ticket, f.get("comment"), session, "tickets");
                    e.target.reset();
                }}>
                    <input type="text" name="comment" required placeholder="Commentaire" style="flex: 1; margin-right: .5em;" />
                    <button type="submit" class="dark-button"></button>
                </form>
            {/if}
        </div>
    {/each}
</div>


<dialog bind:this={createTicketDialog} id="ticket-create-dialog" class="gradient" closedby="any">
    <h1>{cmdStr} un Ticket</h1>
    <form id="user-form" onsubmit={e=>{e.preventDefault(); submitTicket()}}>
        <input
            type="text"
            bind:value={ticketInput.title}
            required
            maxlength="50"
            placeholder="Titre"
            style="font-weight: bold;"
        />

        <div style="padding: 0.5em;">
            <select
                bind:value={ticketInput.priority}
                onchange={()=>{createTicketDialog.style.cssText = `--background-base-color: ${priorities[ticketInput.priority].color};`;}}
                required
            >
                <option value={undefined} disabled selected>Priorité</option>
                {#each priorities as prioData, index }
                    <option value={index}>{prioData.name}</option>
                {/each}
            </select>

            <select
                bind:value={ticketInput.location}
                required
            >
                <option value={undefined} disabled selected>Emplacement</option>
                {#each Object.entries(tickets_trs.locations) as [loc_id, loc_name] }
                    <option value={loc_id}>{loc_name}</option>
                {/each}
            </select>
        </div>

        <ul class="multi-select">
            <select
                style="display: block; align-self: center;"
                onchange={e=>{if (!ticketInput.groups) ticketInput.groups = []; ticketInput.groups.push(e.target.value); e.target.value = ""}}
            >
                <option value="" disabled selected>Groupes </option>
                {#if !ticketInput.groups?.includes("public")}
                    <option value="public">Publique</option>
                {/if}
                <optgroup label="Groupes">
                    {#each Object.entries(groups).filter(g => ! ticketInput.groups?.includes(g[0]) && g[0] != "public" && g[0] != user.id) as [group_id, group_name] }
                        <option type="button" value={group_id}>{group_name}</option>
                    {/each}
                </optgroup>
                <optgroup label="Utilisateurs">
                    {#each Object.entries(userlist).filter(u => ! ticketInput.groups?.includes(u[0]) && u[0] != user.id) as [us_id, us_name] }
                        <option type="button" value={us_id}>{us_name}</option>
                    {/each}
                </optgroup>
            </select>
            {#if ticketInput.groups?.length}
                {#each ticketInput.groups as gid, index }
                    <li style="font-weight: bold;">
                        <button type="button" onclick={()=>{ticketInput.groups.splice(index, 1)}}></button>
                        {displayNames({...userlist, ...groups}, [gid])}
                    </li>
                {/each}
            {/if}
        </ul>

        <textarea bind:value={ticketInput.description} placeholder="Description" class="description" style="height: 10lh;"></textarea>
    </form>
    <button class="dark-button" type="submit" form="user-form">{cmdStr} &thinsp;󰺦</button>
    <button class="dark-button" command="close" commandfor="ticket-create-dialog">Fermer </button>
</dialog>
